/**
 * Enum for Pci Images
 */
export enum PciImages {
  pciCreditCardCredimatic = "pciCreditCardCredimatic",
  pciCreditCard = "pciCreditCard",
  pseImage = "pseImage",
  pseTransferImage = "pseTransferImage",
  webpayPlusImage = "webpayPlusImage",
  webpayOneClickImage = "webpayOneClickImage",
  etPayImage = "etPayImage",
  facilitoImage = "facilitoImage",
  redEfectivaImage = "redEfectivaImage",
  stpImage = "stpImage",
  bancoBogotaImage = "bancoBogotaImage",
  pciPuntoRed = "pciPuntoRedImage",
  stoneImage = "stoneImage",
  none = "",
  webpayImage = "webpayImage",
}



// WEBPACK FOOTER //
// ./src/shared/PciImages.ts